<template>
  <button
    :disabled="disabled"
    @click.prevent="handleClick"
    :class="classObject"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Number,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
  },
  computed: {
    classObject: function () {
      const { value: selectedValue } = this.getButtonGroupState();
      return {
        selected: this.value === selectedValue,
      };
    },
  },
  methods: {
    handleClick() {
      const { update } = this.getButtonGroupState();
      if (!this.disabled) {
        update(this.value);
      }
    },
  },
  inject: ["getButtonGroupState"],
};
</script>

<style lang="scss" scoped>
@import "~@web-components/scss/components/_baseActionButton.scss";
</style>
